// Vue
import {Vue, Component, Prop} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from './../icon/Icon'

@Component({
    name: 'Breadcrumb',
    components: {Icon},
    mixins: [
        template,
    ]
})
export class Breadcrumb extends Vue {

    public get themeMap() {
        const themeMap = {
            default: 1,
            secondary: 2
        }

        return themeMap[this.theme]
    }

    public get routes() {

        return this.crumbs || this.$route.matched
    }

    public get isHomeActive() {
        return (this.$route && this.home.to && this.home.to.name == this.$route.name) || this.home.active
    }

    @Prop({type: [Object], default: () => ({to: {name: 'home'}, active: false})})
    public home!: any

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public crumbs!: {
        meta?: {key: string} | null;
        name: string;
        title: string;
        params?: {[key: string]: string};
        alternatives?: {
            meta?: {key: string} | null;
            name: string;
            title: string;
            params?: {[key: string]: string};
            key?: string;
            active: boolean;
        }[]
        key: string;
        active: boolean;
    }[]

    @Prop()
    public top!: string

    @Prop()
    public hasTop!: boolean

    public created() {

    }

    public handleScrollToTop(e) {

        this.$nextTick(() => {

            const doc = document.documentElement

            const scrollStep = -window.scrollY / (1000 / 15)

            const interval = setInterval(() => {


                if ( window.scrollY != 0 ) {
                    window.scrollBy( 0, scrollStep )
                } else {
                    clearInterval(interval)
                }

            }, 1)
        });
    }
}